import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Портал в body. Нужен для sheet/modal/toast: внутри дерева экрана они
 * попадают под `transform`/`filter` родителя (particle-поле, bloom) и
 * position: fixed начинает считаться от него, а не от вьюпорта.
 */
export function Portal({ children }: { children: ReactNode }): ReactNode {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted || typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
